export default {
  navigation: {
    brand: 'Rootsence',
    links: {
      marketplace: '市场',
      pricing: '定价',
      blog: '博客',
    },
    buttons: {
      getStarted: '开始使用',
      openMenu: '打开菜单',
      closeMenu: '关闭菜单',
    },
  },
  mainContent: {
    targetUsers: '目标用户:非技术创作者、运营人员、知识工作者',
    titles: {
      first: '世界首个Vibe Workflow平台',
      second: '像聊天一样轻松配置 AI 工作流',
    },
    description: '像和朋友聊天一样描述需求，用户就能轻松搭建专属 AI 工作流。',
    buttons: {
      getStarted: '开始使用',
    },
  },
  pageContent: {
    subtitle: '将你的创意构想，转化为高效自动化工作流',
    mission: {
      title: '展现每个人身上不可复制的知识储备',
      description:
        '不管是你摸索出的高效工作技巧，还是深耕领域的独门经验，都能被 AI 转化为可分享、 可创收的实用模板。',
    },
    ceoSection: {
      automatedWorkflows: 'AUTOMATED WORKFLOWS',
    },
  },
  pageStat: {
    title: '选对工具 = 效率翻倍',
    description: '三大核心亮点，解锁高效自动化新体验',
    cards: [
      {
        title: '全链路需求满足',
        description: '无需编程基础，5 分钟即可快速搭建你的首个自动化工作流',
      },
      {
        title: '极速上手无门槛',
        description: '一站式承接自动化部署、流程优化与业务规模化全周期需求',
      },
      {
        title: '共享变现轻松创收',
        description: '发布原创自动化方案，他人每一次使用，均可获得对应积分奖励与收益分成',
      },
    ],
  },
  pageList: {
    title: '一站式自动化工作流创作平台',
    description: '模板复用・应用集成・发布方案即赚收益',
    feature: '特点',
    cards: [
      {
        title: 'AI Copilot',
        description: '自然语言描述需求,自动生成完整工作流',
      },
      {
        title: '可视化执行',
        description: '每一步执行清晰可见，实时显示状态和结果',
      },
      {
        title: '智能节点',
        description: '每个节点都是AI Agent,自动理解上下文',
      },
      {
        title: '多线程对话',
        description: '独立管理多个会话,避免上下文混乱',
      },
    ],
  },
  pageOption: {
    title: '市场竞争与差异化',
    description: '自动化流程所需的功能，尽汇于此。',
    tabs: [
      {
        title: '与Dify对比',
        points: [
          '面向日常工作自动化，5分钟上手',
          '实时多人协作(CRDT),类似Google Docs.',
          '创作者变现生态:发布模板赚取20%收益。',
        ],
      },
      {
        title: '与n8n对比',
        points: [
          '无需编程，自然语言构建工作流',
          '2节点vs10+节点，效率差距巨大.',
          '智能节点:每个节点都是Al Agent',
        ],
      },
    ],
  },
  pageGroup: {
    title: '应用场景与用户群体',
    description: '满足不同用户群体的需求',
    groups: [
      {
        title: '内容创作者',
        description: '自媒体运营、视频创作、撰写写作',
        icon: '📝',
      },
      {
        title: '运营人员',
        description: '账户管理、数据收集、客户沟通',
        icon: '📊',
      },
      {
        title: '研究人员',
        description: '学术文献整理、行业资讯追踪、知识库管理',
        icon: '🔬',
      },
      {
        title: '小团队/创业公司',
        description: '营销自动化、客户支持、内部流程优化',
        icon: '🚀',
      },
    ],
  },
  pageSlide: {
    title: '一键对接 3000 + 工具',
    description: '零配置、无门槛、无复杂操作 自动搞定 90% 日常工作',
  },
  pageCombo: {
    title: '常见问题解答',
    description: '快速查看常见问题的解答',
    faqs: [
      {
        question: 'AIMfly是一个什么样的产品？',
        answer:
          '借助 AI 的力量，您可以轻松实现重复任务自动化，构建个性化工作流，复用优质模板。它是创作者与高效团队不可或缺的智能伙伴。',
      },
      {
        question: '使用AIMfly需要具备技术吗？',
        answer:
          '完全不需要。您可以直观地构建工作流程，便用现有模板,或者让 Copiot生成工作流。无需任何编码。',
      },
      {
        question: '我的数据在AIMfly中安全吗？',
        answer:
          '是的。您的数据绝对私密，所有连接的工具都遵循 OAuth安全认证机制，我们非常重视数据保护。',
      },
      {
        question: '如何将我的工作打包成模板？',
        answer: '通过审核后，你的工作流即可上架模板市场。优秀的工作流程可以为你吸引更多关注者。',
      },
      {
        question: '支持那些文档格式？',
        answer:
          '支持演示文稿(PPT/PDF)、文档(Word/Markdown/PDF)、电子表格(Excel/CSV) 项目计划、会议记录等。所有输出均为生产就绪且完全格式化。',
      },
    ],
  },
  pageSubscribe: {
    title: '订阅',
    description: '请选择您的订阅方案',
    plans: [
      {
        title: '免费计划',
        subtitle: '开启创意之旅的基础点',
        price: '$ 0 /月',
        features: ['每日100积分', '适合试用简单工作流'],
        button: '免费',
        highlight: false,
      },
      {
        title: 'Starter计划',
        subtitle: '升级你的计划获取更多权益',
        price: '$ 24.9 /月',
        features: ['每日300积分+每月2000积分', '可访问庞大的工具库'],
        button: '立即开通',
        highlight: false,
      },
      {
        title: 'Maker计划',
        subtitle: '升级你的计划获取更多权益',
        price: '$ 49.9 /月',
        features: ['每日300积分+每月4000积分', '可访问庞大的工具库', '服务支持：高级优先支持'],
        button: '立即开通',
        highlight: true,
      },
      {
        title: '企业计划',
        subtitle: '升级你的计划获取更多权益',
        price: '独家定制',
        features: ['即将上线，敬请期待'],
        button: '即将上线',
        highlight: false,
      },
    ],
  },
  pageContact: {
    title: '联系我们',
    form: {
      name: '姓名',
      namePlaceholder: '请输入您的姓名',
      nameRequired: '请输入您的姓名',
      phone: '电话',
      phonePlaceholder: '请输入您的电话',
      email: '邮箱',
      emailPlaceholder: '请输入您的邮箱',
      emailRequired: '请输入您的邮箱',
      wechat: '微信',
      wechatPlaceholder: '请输入您的微信',
      message: '留言',
      messagePlaceholder: '请输入您的想法和建议',
      consent: '为使您获得一套更符合自身的体验，我们可能使用您提供的信息来改善服务',
      button: '预约体验',
      submitSuccess: '提交成功！我们将尽快与您联系。',
      submitFailed: '提交失败，请重试。',
      submitError: '发生错误，请稍后重试。',
    },
  },
  pageInvite: {
    subtitle: 'AI 驱动 + 多工具集成',
    title: '简单而智能的工作流程',
    tagline: '创造 · 发布 · 收益',
    button: '开始使用',
  },
};
